import React, { useState } from 'react';
import ProjectRequestSidePanel from './components/ProjectRequestSidePanel';

import { useProjectRequests } from './hooks/useProjectRequests';
import { useHighlight } from '../../hooks/useHighlight';
import { useConvertToDeal } from '../customer-contacts/hooks/useConvertToDeal';

import ProjectRequestFilters from './components/ProjectRequestFilters';
import ProjectRequestTable from './components/ProjectRequestTable';
import Pagination from '../../components/ui/Pagination';
import { renderBooleanCell, renderWorkRequestBadges } from './utils/projectRequestHelpers';

const ProjectRequestsListPage: React.FC = () => {
  const [selectedRequestId, setSelectedRequestId] = useState<number | null>(null);
  const [openInEditMode, setOpenInEditMode] = useState(false);

  const {
    customers,
    selectedCustomer,
    setSelectedCustomer,
    status,
    setStatus,
    data,
    loading,
    error,
    setError,
    searchQuery,
    setSearchQuery,
    filteredRequests,
    currentPage,
    setCurrentPage,
    itemsPerPage,
    setItemsPerPage,
    totalPages,
    startIndex,
    endIndex,
    currentRequests,
    handlePageChange,
    load,
  } = useProjectRequests();

  const { highlightedId } = useHighlight(data, 'data-project-id');
  const { converting, handleConvert } = useConvertToDeal(setError);

  return (
    <div className="max-w-full mx-auto theme-card rounded-2xl p-3 md:p-4">
      <h1 className="text-xl font-semibold mb-3 theme-text-primary">Project Requests</h1>

      {error && <div className="mb-3 p-2 rounded bg-red-50 text-red-700 border border-red-200 text-sm">{error}</div>}

      <ProjectRequestFilters
        customers={customers}
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        status={status}
        setStatus={setStatus}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        onRefresh={() => load()}
      />

      <ProjectRequestTable
        currentRequests={currentRequests}
        customers={customers}
        highlightedId={highlightedId}
        converting={converting}
        loading={loading}
        searchQuery={searchQuery}
        renderBooleanCell={renderBooleanCell}
        renderWorkRequestBadges={renderWorkRequestBadges}
        onConvert={handleConvert}
        onView={(id) => {
          setOpenInEditMode(false);
          setSelectedRequestId(id);
        }}
        onEdit={(id) => {
          setOpenInEditMode(true);
          setSelectedRequestId(id);
        }}
      />

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        itemsPerPage={itemsPerPage}
        startIndex={startIndex}
        endIndex={endIndex}
        total={filteredRequests.length}
        loading={loading}
        onPageChange={handlePageChange}
        onItemsPerPageChange={(perPage) => {
          setItemsPerPage(perPage);
          setCurrentPage(1);
        }}
      />

      {/* Side Panel */}
      {selectedRequestId && (
        <ProjectRequestSidePanel
          requestId={selectedRequestId}
          onClose={() => {
            setSelectedRequestId(null);
            setOpenInEditMode(false);
          }}
          onUpdate={() => load()}
          initialEditMode={openInEditMode}
        />
      )}
    </div>
  );
};

export default ProjectRequestsListPage;
